import { Badge, Button } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icons/Icon'
import createAccount from '../../images/Icon_Account_CreateAccount.svg'
import getSubdomain from 'utils/getSubdomain'
import { ChatBlockedAlert } from './ChatBlockedAlert'

const medicareEnv = process.env.REACT_APP_MEDICARE_ENV || ''
const medicareSubdomain = getSubdomain(medicareEnv)
export const createAccountUrl = `https://${medicareSubdomain}medicare.gov/account/create-account`

type UnauthChatMenuProps = {
  loginUrl: string
  onOpenGuestChat: () => void
  onClickLogin?: () => void
  onClickRegister?: () => void
  chatBlocked?: boolean
}
export const UnauthChatMenu = ({
  chatBlocked,
  loginUrl,
  onOpenGuestChat,
  onClickLogin,
  onClickRegister
}: UnauthChatMenuProps) => {
  const { t } = useTranslation('liveChat')

  return (
    <div className="ch-c-livechat-menu">
      <div>
        <Badge variation="info" className="ch-c-badge__secondary-lightest">
          <Icon text="" img={createAccount} /> {t('unauth.nudge.pill')}
        </Badge>
        <p className="ds-text-body--md ds-u-margin-bottom--2">
          {t('common.description')}
        </p>
        <a
          href={loginUrl}
          className="ds-c-button ds-c-button--primary-alt"
          onClick={onClickLogin}
        >
          {t('unauth.nudge.loginButton')}
        </a>
        <a
          href={createAccountUrl}
          className="ds-u-display--block ds-u-margin-top--2 ds-u-sm-display--inline-block ds-u-sm-margin-top--0 ds-u-sm-margin-left--2"
          onClick={onClickRegister}
        >
          {t('unauth.nudge.createAccountLink')}
        </a>
      </div>
      <hr className="ch-c-livechat-menu-divider ds-u-margin-y--2" />
      <div>
        <p className="ds-text-body--md ds-u-margin-bottom--2">
          {t('unauth.guest.description')}
        </p>
        <Button
          title="Start Guest Chat - Opens in a new window"
          className="ds-c-button"
          data-testid="guest-chat-btn"
          onClick={onOpenGuestChat}
          type="button"
        >
          {t('unauth.guest.button')}
        </Button>
      </div>

      {chatBlocked && <ChatBlockedAlert />}
    </div>
  )
}
